var _line, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScalpel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.52148,
    y1: 104.756,
    x2: 112.658,
    y2: 104.756,
    stroke: "#BAC9D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8618 13.2762C93.1933 9.60771 87.9382 8.91564 85.1235 11.7304C84.5327 12.3212 83.9238 12.9764 83.2685 13.7104C82.46 14.6153 81.5793 15.6415 80.57 16.8176L80.5607 16.8297C79.7783 17.7408 78.9171 18.7438 77.9536 19.8491L24.0137 79.4823L30.6558 86.1244L90.2889 32.1845C91.3942 31.2209 92.3972 30.3597 93.3084 29.5774L93.3204 29.5681L93.349 29.5435C95.4643 27.7274 97.094 26.3282 98.4077 25.0146C101.222 22.1999 100.53 16.9448 96.8618 13.2762ZM86.3757 16.5801C84.42 18.5357 81.7642 24.3624 83.7199 26.318C85.6756 28.2737 91.5022 25.6179 93.4579 23.6622C95.4136 21.7065 95.4136 18.5357 93.4579 16.5801C91.5022 14.6244 88.3314 14.6244 86.3757 16.5801Z",
    fill: "#BAC9D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6686 80.9873L4.5 102.156L29.0211 91.7385L29.6982 85.0169L25.6686 80.9873ZM27.4863 90.7919L9.62704 98.3791L28.066 85.037L27.4863 90.7919Z",
    fill: "#BAC9D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalpel);
export default __webpack_public_path__ + "static/media/Scalpel.37481bda.svg";
export { ForwardRef as ReactComponent };